import React from 'react';

interface ErrorType {
  error: string[];
}

export const Error: React.FC<ErrorType> = ({ error }) => {
  return error ? <div className="mt-1 text-[13px] text-red-600">{error.join(', ')}</div> : null;
};
